// extracted by mini-css-extract-plugin
export var contentBody = "_78-9";
export var headerImage = "_78-2";
export var imageButton = "_78-7";
export var imageButtonIcon = "_78-8";
export var imageHeader = "_78-4";
export var imageHeaderText = "_78-5";
export var imageOverlay = "_78-3";
export var imageTitle = "_78-6";
export var imageWrapper = "_78-1";
export var taskList = "_78-a";
export var widget = "_78-0";